import React, {useEffect, useState} from "react";
import {useCookies} from "react-cookie";
import axios from "axios";
import * as constants from "../constants/domains";
import Loading from "./ui/Loading";

const IsUserAuth = () => {
    const [loading,setLoading] = useState(false);
    const [isFirstTime , setIsFirstTime] = useState(true)

    const Cookie = useCookies(['user_server_token']);
    const cookies = Cookie[0];
    const removeCookie = Cookie[2];
    const {user_server_token} = cookies;

    useEffect(() => {
        if (!isFirstTime){
            return
        }
        setIsFirstTime(false);
        if (user_server_token){
            setLoading(true)
            axios.post(constants.$apiUrl + '/api/check-token', [],{
                headers: {
                    "Authorization": "Bearer " + user_server_token,
                    'Access-Control-Allow-Origin': '*',
                    'Content-type': 'application/json',
                }
            })
                .then(() => {
                    window.location.replace(constants.$shopUrl);
                })
                .catch(() => {
                    removeCookie("user_server_token" , { domain: constants.$cookieURL ,path: '/' });
                    window.location.replace(constants.$shopUrl);
                })
        }


    }, [isFirstTime, user_server_token , removeCookie])


        let content = <React.Fragment />;

        if (loading){
            content = <React.Fragment>
                <div style={{
                    background: "#ffffff",
                    display: "block",
                    width: "100%",
                    height: '100%',
                    position: "fixed",
                    top: 0,
                    left: 0,
                    zIndex: 4999,
                }}/>
                <Loading/> </React.Fragment>
        }


        return content;



}


export default IsUserAuth;